module.exports = __webpack_public_path__ + "static/media/ratx.f9ab0882.svg";